import React from 'react'
import ReactSVG from 'react-svg'

import { connect } from 'react-redux'

import useTranslation from 'next-translate/useTranslation'

import { setShowFilterModal } from 'SRC/modules/vehicleParts/list/actions'

const FilterButtons = ({ filtersCount, setShowFilterModal }) => {
	const { t } = useTranslation('common')

	return (
		<ul className='filter-navigation filter-navigation-vehicle-parts'>
			<li className='filter-navigation-item'>
				<a href='javascript:void(0)' onClick={() => { setShowFilterModal('text') }} style={{ width: '100%' }}>
					<ReactSVG
						src={'/icons/pretraga-po-kataloskom-broju.svg'}
						beforeInjection={svg => {
							svg.setAttribute('style', 'width: auto; margin-top: 5px; height: 35px;')
						}} wrapper='span'
					/>
					<div className='filter-navigation-item-text'>
						<p>{t('Pretraga')}</p>
						<p>{t('Kataloški broj')}</p>
					</div>
				</a>
			</li>

			<li className='filter-navigation-item'>
				<a href='javascript:void(0)' onClick={() => { setShowFilterModal('filters') }} style={{ width: '100%' }}>
					<ReactSVG
						src={'/icons/pretraga-po-filterima.svg'}
						beforeInjection={svg => {
							svg.setAttribute('style', 'width: auto; margin-top: 5px; height: 28px;')
						}} wrapper='span'
					/>

					<div className='filter-navigation-item-text' style={{ position: 'relative' }}>
						<p>{t('Pretraga')}</p>
						<p>{t('po filterima')}</p>
					</div>

					{filtersCount > 0 && (
						<div className='filter-navigation-count'>
							<span>{filtersCount}</span>
						</div>
					)}
				</a>
			</li>
		</ul>
	)
}

export default connect(null, { setShowFilterModal })(FilterButtons)
